module.exports = __webpack_public_path__ + "img/folios-icon.b3086ae3.svg";